import { BoMItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'
import { getPreviousAndNextItemByAssembly } from './getPreviousAndNextItemByAssembly'
import { getPreviousAndNextItemByMaterialHeader } from './getPreviousAndNextItemByMaterialHeader'
import { getPreviousAndNextItemOfProject } from './getPreviousAndNextItemOfProject'
import { getPreviousAndNextItemOfRoute } from './getPreviousAndNextItemOfRoute'

export type BomItemPointer = {
  bomItemId: string
  bomItemType: BoMItemType
}

export const previousAndNextBomItemIdsSelector =
  (bomItemId: string) => (state: RootAppState) => {
    if (bomItemId === state.project?.activeProject?.id) {
      // project, next is the first assembly that satisfy the active filters, previous is null
      return getPreviousAndNextItemOfProject(state)
    }

    const getPreviousAndNext = {
      [ProjectViews.SalesView]: getPreviousAndNextItemByAssembly(
        state,
        bomItemId
      ),
      [ProjectViews.PurchaseView]: getPreviousAndNextItemByMaterialHeader(
        state,
        bomItemId
      ),
      [ProjectViews.RoutesView]: getPreviousAndNextItemOfRoute(
        state,
        bomItemId
      ),
      [ProjectViews.AssemblyHierarchy]: getPreviousAndNextItemByAssembly(
        state,
        bomItemId
      ),
    }

    return (
      getPreviousAndNext[state.project.currentView] ||
      getPreviousAndNext[ProjectViews.SalesView]
    )
  }
